import { render, staticRenderFns } from "./imageCheckWrapperforNewTask.vue?vue&type=template&id=2ff52920&scoped=true&"
import script from "./imageCheckWrapperforNewTask.vue?vue&type=script&lang=js&"
export * from "./imageCheckWrapperforNewTask.vue?vue&type=script&lang=js&"
import style0 from "./imageCheckWrapperforNewTask.vue?vue&type=style&index=0&id=2ff52920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff52920",
  null
  
)

export default component.exports